import { $cmsData, settings } from "../common/setting";
import { cr, URLS } from "fire-wind-water";
declare const $cz: any;
export function splitContainer(data) {
  $cmsData.container = {};
  $cmsData.data = data;
  if (data.items) {
    console.log(data.items);
    cr.each(data.items, (d) => {
      if (!d.historyContent || d.isShow === 2 || d.isShow === 0) {
        return;
      }
      d.historyContent.id = d.id;
      d.historyContent.isShow = d.isShow;
      d.historyContent.isDesign = settings.isDesign;
      d.historyContent.isPreview = settings.isPreview;
      if (!d.historyContent.type) {
        d.historyContent.type = d.type;
      }
      if (d.historyContent.type === "NAV") {
        cr.each(d.historyContent.content.items, (l) => {
          if (
            [2, 3, 4, 6, 7].indexOf(parseInt(l.type, 10)) > -1 ||
            l.linkType == "system"
          ) {
            l.link = `${l.href.url}?tid=${settings.tenantId}&sid=${settings.siteId}&cy=${settings.category}&pid=${l.href.pageId}&t=${settings.t}`;
          }
          if (l.subItems) {
            cr.each(l.subItems, (b) => {
              if (
                [2, 3, 4, 6, 7].indexOf(parseInt(b.type, 10)) > -1 ||
                b.linkType == "system"
              ) {
                b.link = `${b.href.url}?tid=${settings.tenantId}&sid=${settings.siteId}&cy=${settings.category}&pid=${b.href.pageId}&t=${settings.t}`;
              }
            });
          }
        });
      }
      const pt: string[] = ["MEETING", "MIMAGETEXT", "VIDEO", "FILE", "SEARCH"];
      if (pt.indexOf(d.historyContent.type) !== -1) {
        const pageJson = {
          MEETING: "./meetingList.html",
          MIMAGETEXT: "./articleList.html",
          VIDEO: "./videoList.html",
          FILE: "./fileList.html",
          SEARCH: "./searchInfo.html",
        };
        const page: string = pageJson[d.historyContent.type] || "./index.html";
        d.historyContent.content.moreLink = `${page}?tid=${settings.tenantId}&sid=${settings.siteId}&pid=${d.historyContent.content.morePageId}&cy=${settings.category}&t=${settings.t}`;
        if (URLS.getURL("preview")) {
          d.historyContent.content.moreLink += "&preview=1";
        }
        const count: number =
          parseInt(d.historyContent.content.showCount, 10) || 4;
        const items: any[] = d.historyContent.content.items;
        if (items && items.length > count) {
          d.historyContent.content.items.splice(count, items.length);
        }
      }
      if (d.historyContent.type === "REGISTRATION") {
        cr.each(data.items, (z) => {
          if (z.historyContent.type === "NAV" || z.type === "NAV") {
            d.historyContent.isNavShow = z.isShow === 1 || z.isShow === 3;
            settings.isNavShow = d.historyContent.isNavShow;
          }
        });
      }
      const container = d.historyContent.container || "sk-cms-main";
      if (!$cmsData.container[container]) {
        $cmsData.container[container] = [];
      }
      const style = {};
      if (d.historyContent.type === "TAB") {
        for (const key in d.historyContent.style) {
          const style2 = {};
          cr.each(d.historyContent.style[key], (h) => {
            style2[h.key] = h.value;
          });
          style[key] = style2;
        }
      } else {
        cr.each(d.historyContent.style, (h) => {
          style[h.key] = h.value;
        });
      }
      d.historyContent.style = style;
      $cz.event("data", d);
      $cmsData.container[container].push(d);
    });
  }
  $cz.event("container", $cmsData.container);
}

export function updateContainer(res) {
  const data = {
    category: res.category,
    content: res.content,
    historyContent: res.content,
    orderId: res.index,
    historyOrderId: res.index,
    id: res.content.id,
    name: res.content.name,
    type: res.content.type,
    container: res.content.container,
  };
  const style = {};
  cr.each(data.content.style, (h) => {
    style[h.key] = h.value;
  });
  data.content.style = style;
  if (!$cmsData.container[data.container]) {
    $cmsData.container[data.container] = [];
  }
  const o = $cmsData.container[data.container];
  let isAdd = true;
  for (let i = 0; i < o.length; i++) {
    if (o[i].id == data.id) {
      o[i] = data;
      isAdd = false;
      break;
    }
  }
  if (isAdd) {
    o.push(data);
    $cmsData.data.push(data);
  } else {
    cr.each($cmsData.data, (d, i) => {
      if (d.id == data.id) {
        $cmsData.data[i] = data;
        return false;
      }
    });
  }
}
